import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-delete-extension-dialog',
    styleUrls: ['./delete-extension-dialog.component.scss'],
    templateUrl: './delete-extension-dialog.component.html',
    standalone: false
})
export class DeleteExtensionDialogComponent {
   autoAttendantExtensionList: any = [];

   fmFmExtensionList: any = [];

   queueExtensionsList: any = [];

   huntGroupExtensionsList: any = [];

   form: any;

   uniqueHuntGroupExtensions = new Set();

   isUsedOnOtherExtensions: boolean;

   constructor(
      private dialogRef: MatDialogRef<DeleteExtensionDialogComponent>,
      @Inject(MAT_DIALOG_DATA) private data: any
   ) {
      this.autoAttendantExtensionList = data.autoAttendantsUsingForTimeout;
      this.fmFmExtensionList = data.fmFmsUsingForFinalDestination;
      this.queueExtensionsList = data.queuesUsingForExitRoute;
      this.huntGroupExtensionsList = data.huntGroupsUsingForRouteBusy
         .concat(data.huntGroupsUsingForRouteNoAnswer)
         .filter((item) => {
            if (!this.uniqueHuntGroupExtensions.has(item.extensionId)) {
               this.uniqueHuntGroupExtensions.add(item.extensionId);
               return true;
            }
            return false;
         });
      this.isUsedOnOtherExtensions =
         this.fmFmExtensionList.length > 0 ||
         this.autoAttendantExtensionList.length > 0 ||
         this.queueExtensionsList.length > 0 ||
         this.huntGroupExtensionsList.length > 0;
   }

   onConfirm(): void {
      this.dialogRef.close(true);
   }

   onCancel(): void {
      this.dialogRef.close(false);
   }
}